(function () {
  'use strict';

  var LOG_PREFIX = '[geo-banner]';

  var dataEl = document.getElementById('geo-banner-data');
  var banner = document.getElementById('geo-banner');
  if (!dataEl || !banner) {
    console.warn(LOG_PREFIX, 'snippet not in DOM — banner cannot run');
    return;
  }

  var config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error(LOG_PREFIX, 'failed to parse data blob', e);
    return;
  }

  var DEBUG = !!config.debug;
  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  var storageKey = config.storageKey || 'spikeball_geo_banner_dismissed_at';
  var ttlMs = (config.ttlDays || 7) * 24 * 60 * 60 * 1000;
  var endpoint = config.suggestionsEndpoint || '/browsing_context_suggestions.json';
  var currentIso = ((config.current && config.current.iso) || '').toUpperCase();
  var countries = config.countries || {};

  log('init', { currentIso: currentIso, countryCount: Object.keys(countries).length });

  function readDismissedAt() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      if (!raw) return 0;
      var ts = parseInt(raw, 10);
      return isNaN(ts) ? 0 : ts;
    } catch (e) { return 0; }
  }

  function writeDismissedAt() {
    try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
  }

  function getQueryParam(name) {
    var m = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function lookupCountry(iso) {
    if (!iso) return null;
    var info = countries[iso.toUpperCase()];
    if (info) {
      return {
        iso: iso.toUpperCase(),
        name: info.name,
        currency_iso: info.currency_iso,
        currency_symbol: info.currency_symbol
      };
    }
    return { iso: iso.toUpperCase(), name: iso.toUpperCase(), currency_iso: '', currency_symbol: '' };
  }

  function fillTemplate(el, replacements) {
    if (!el) return;
    var text = el.textContent;
    for (var key in replacements) {
      if (Object.prototype.hasOwnProperty.call(replacements, key)) {
        text = text.split(key).join(replacements[key]);
      }
    }
    el.textContent = text;
  }

  function wireActions() {
    var sel = banner.querySelector('[data-geo-banner-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var value = sel.value;
        if (value === 'switch') {
          var form = banner.querySelector('#geo-banner-form');
          if (form) {
            log('switch selected — submitting localization form');
            form.submit();
          }
        } else if (value === 'stay') {
          writeDismissedAt();
          banner.hidden = true;
          log('stayed (dismissed via select)');
        }
      });
    }

    var btns = banner.querySelectorAll('[data-geo-banner-dismiss]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        e.preventDefault();
        writeDismissedAt();
        banner.hidden = true;
        log('dismissed via × button');
      });
    }
  }

  function reveal(recommended) {
    log('reveal', recommended);
    var headlineEl = banner.querySelector('[data-geo-banner-headline]');
    var switchOption = banner.querySelector('[data-geo-banner-switch-option]');
    var countryInput = banner.querySelector('[data-geo-banner-country-input]');

    var replacements = {
      '__COUNTRY__': recommended.name || recommended.iso,
      '__COUNTRY_ISO__': (recommended.iso || '').toUpperCase(),
      '__CURRENCY__': recommended.currency_iso || ''
    };
    fillTemplate(headlineEl, replacements);
    fillTemplate(switchOption, replacements);

    if (countryInput) countryInput.value = recommended.iso;

    wireActions();
    banner.hidden = false;
  }

  // Force-show debug path: ?force_geo_banner=1 OR ?force_geo_banner=BE
  var forceParam = getQueryParam('force_geo_banner');
  if (forceParam) {
    var forcedIso = forceParam === '1' ? null : forceParam.toUpperCase();
    if (!forcedIso) {
      // pick first country in map that isn't current
      var keys = Object.keys(countries);
      for (var k = 0; k < keys.length; k++) {
        if (keys[k].toUpperCase() !== currentIso) { forcedIso = keys[k]; break; }
      }
      if (!forcedIso) forcedIso = currentIso === 'US' ? 'BE' : 'US';
    }
    log('force_geo_banner active — bypassing geo fetch', forcedIso);
    reveal(lookupCountry(forcedIso));
    return;
  }

  var dismissedAt = readDismissedAt();
  if (dismissedAt && Date.now() - dismissedAt < ttlMs) {
    log('dismissed within TTL — staying hidden', { dismissedAt: dismissedAt });
    return;
  }

  function checkGeo() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', endpoint, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      log('endpoint response', { status: xhr.status, body: xhr.responseText.slice(0, 200) });

      if (xhr.status < 200 || xhr.status >= 300) {
        log('endpoint returned non-2xx — banner stays hidden');
        return;
      }
      var data;
      try { data = JSON.parse(xhr.responseText); }
      catch (e) { console.error(LOG_PREFIX, 'JSON parse failed', e); return; }

      var detected = data && data.detected_values;
      if (!detected || !detected.country || !detected.country.handle) {
        log('no detected country in response — banner stays hidden');
        return;
      }

      var detectedIso = String(detected.country.handle).toUpperCase();
      log('detected country', { detectedIso: detectedIso, currentIso: currentIso });

      if (detectedIso === currentIso) {
        log('detected == current — no recommendation needed');
        return;
      }

      // Build recommendation, prefer map data (has currency) over endpoint data
      var fromMap = lookupCountry(detectedIso);
      if (!fromMap.name || fromMap.name === detectedIso) {
        // map didn't have it — use endpoint name, no currency
        fromMap.name = detected.country.name || detectedIso;
      }

      reveal(fromMap);
    };
    try { xhr.send(); }
    catch (e) { console.error(LOG_PREFIX, 'xhr send failed', e); }
  }

  checkGeo();
})();

/* ----------------------------------------------------------------------
   Weglot relocator — move Weglot's auto-injected floating widget into
   the header placeholder. Weglot inserts #weglot-switcher-1 as a body-
   level fixed-position element after its JS initializes; we poll for
   it and re-parent it into .header__weglot so it appears in the top nav.
   ---------------------------------------------------------------------- */
(function () {
  'use strict';

  var LOG = '[weglot-relocate]';
  var MAX_TRIES = 60; // ~15s at 250ms interval
  var INTERVAL_MS = 250;

  function relocate() {
    var placeholder = document.querySelector('.header__weglot');
    if (!placeholder) return 'no_placeholder';

    var widget = document.getElementById('weglot-switcher-1');
    if (!widget) {
      // Fallback: any body-level Weglot container
      widget = document.body && document.body.querySelector(':scope > .weglot-container, :scope > .weglot_switcher, :scope > #weglot-language-switcher, :scope > .country-selector');
    }
    if (!widget) return 'no_widget_yet';

    if (placeholder.contains(widget)) return 'already_relocated';

    placeholder.appendChild(widget);
    // Reset fixed-positioning inherited from Weglot defaults so it flows in-line.
    widget.style.position = 'static';
    widget.style.bottom = 'auto';
    widget.style.right = 'auto';
    widget.style.left = 'auto';
    widget.style.top = 'auto';
    widget.style.zIndex = '';
    widget.classList.add('weglot-relocated');
    console.log(LOG, 'relocated #' + (widget.id || '(unknown)') + ' into .header__weglot');
    return 'relocated';
  }

  function start() {
    var status = relocate();
    if (status === 'relocated' || status === 'already_relocated') return;

    var tries = 0;
    var iv = setInterval(function () {
      var s = relocate();
      tries++;
      if (s === 'relocated' || s === 'already_relocated' || tries >= MAX_TRIES) {
        clearInterval(iv);
        if (s !== 'relocated' && s !== 'already_relocated') {
          console.warn(LOG, 'gave up after ' + tries + ' tries — last status: ' + s);
        }
      }
    }, INTERVAL_MS);
  }

  // Listen for Weglot's "languageChanged" event in case Weglot re-renders.
  document.addEventListener('weglotLanguageChanged', function () { setTimeout(relocate, 50); });
  // Also poll on DOMContentLoaded and load to catch slow Weglot init.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () { setTimeout(relocate, 0); });
})();
